module.exports = __webpack_public_path__ + "img/2000.b4975356.jpg";